export class StampaModelloOtticaIN {
    idProgetto: number
}
